// extracted by mini-css-extract-plugin
export var actions = "SupportAssistant-module__actions___L8hae";
export var answer = "SupportAssistant-module__answer___b365W";
export var card = "SupportAssistant-module__card___oTaZH";
export var cardTitle = "SupportAssistant-module__cardTitle___oRiTN";
export var chat = "SupportAssistant-module__chat___WSbUV";
export var chatHeader = "SupportAssistant-module__chatHeader___5MM-M";
export var chatTitle = "SupportAssistant-module__chatTitle___n9qoA";
export var chip = "SupportAssistant-module__chip___pE70A";
export var chips = "SupportAssistant-module__chips___o3Xx7";
export var codeBlock = "SupportAssistant-module__codeBlock___D6VeT";
export var codeHeader = "SupportAssistant-module__codeHeader___7msoY";
export var confirm = "SupportAssistant-module__confirm___u4hL8 SupportAssistant-module__notice___hteof";
export var details = "SupportAssistant-module__details___ZqnvP";
export var disclaimer = "SupportAssistant-module__disclaimer___uZmyN";
export var escalation = "SupportAssistant-module__escalation___f2ieW";
export var escalationSummary = "SupportAssistant-module__escalationSummary___H1zoD";
export var iconButton = "SupportAssistant-module__iconButton___34MDa";
export var inlineLink = "SupportAssistant-module__inlineLink___M4S4F";
export var inputBox = "SupportAssistant-module__inputBox___cRxb+";
export var inputFooter = "SupportAssistant-module__inputFooter___L2R0c";
export var linkList = "SupportAssistant-module__linkList___L05ce";
export var markdown = "SupportAssistant-module__markdown___YNVSR";
export var messages = "SupportAssistant-module__messages___I6gJn";
export var notice = "SupportAssistant-module__notice___hteof";
export var pending = "SupportAssistant-module__pending___lDaYC";
export var section = "SupportAssistant-module__section___-aRhw SupportHelpButton-module__section___BxDdF";
export var select = "SupportAssistant-module__select___TlbBe";
export var sendButton = "SupportAssistant-module__sendButton___9qmOi";
export var subheading = "SupportAssistant-module__subheading___7SYo8";
export var tableBlock = "SupportAssistant-module__tableBlock___I4W8N";
export var tableCenter = "SupportAssistant-module__tableCenter___+KkqE";
export var tableRight = "SupportAssistant-module__tableRight___BzlCc";
export var textButton = "SupportAssistant-module__textButton___F-K6H";
export var textarea = "SupportAssistant-module__textarea___WtEvM";
export var userMessage = "SupportAssistant-module__userMessage___6cu3e";
export var visuallyHidden = "SupportAssistant-module__visuallyHidden___08WYS";